import { useTranslation } from "react-i18next";

interface HelpLinkProps {
  href: string;
  label?: string;
  target?: string;
  className?: string;
}
export default function HelpDocsLink({
  href,
  label,
  target = "_blank",
  className,
}: HelpLinkProps) {
  const { t } = useTranslation();

  return (
    <a
      href={href}
      target={target}
      rel="noreferrer"
      className={` inline-flex items-center text-blue-500 ${className}`}
    >
      <span>{label ?? t("need-help")}</span>
    </a>
  );
}
